module.exports = __webpack_public_path__ + "static/img/rx.7e50820.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/rx.png
// module id = HfTo
// module chunks = 1